export { Assert } from './misc/Assert';
export { Defer } from './misc/Defer';
export { L10N } from './misc/L10N';
export { Logger } from './misc/Logger';
export { Options } from './misc/Options';
export { l } from './strings/Strings';

import { Logger } from './misc/Logger';

// Generated by webpack at compile time.
// We want to disable the logger in minified mode because this can cause slowdown for pages in production.
declare const DISABLE_LOGGER;
if (DISABLE_LOGGER) {
  Logger.disable();
}



// WEBPACK FOOTER //
// ./src/MiscModules.ts